import React from 'react';
import { Form, Input, Select, Checkbox, Upload, Button, InputNumber } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { CUSTOMFIELD_TYPE_OPTIONS, CUSTOMFIELD_IMAGE_MODE_OPTIONS } from '../../../../../data/constant';
import { CUSTOMFIELD_TYPE_FEATURE, hasCompanyFeature } from '../../../../../data/companyFeatures';

function FormEmployee({ formRef, onFinish, initialValues = {}  }) {
  // type=6 (Image) เท่านั้นถึงโชว์ตั้งค่ารูป (single/multi + workload ต่อรูป)
  const [type, setType] = React.useState(initialValues.type);
  React.useEffect(() => { setType(initialValues.type); }, [initialValues.type]);
  const isImage = Number(type) === 6;

  // บาง type ผูกกับระบบเฉพาะบริษัท (เช่น เช็คโปรวันเกิด = ต้องมีตัวเชื่อมเว็บหลังบ้าน)
  // บริษัทอื่นไม่ต้องเห็นเป็นตัวเลือก เพราะเลือกไปก็ใช้ไม่ได้
  const typeOptions = CUSTOMFIELD_TYPE_OPTIONS.filter((option) =>
    hasCompanyFeature(CUSTOMFIELD_TYPE_FEATURE[option.value])
  );

  return (
    <Form
      name="Form"
      ref={formRef}
      layout="vertical"
      onFinish={onFinish}
      initialValues={initialValues}
      onValuesChange={(changed) => { if ('type' in changed) setType(changed.type); }}
    >
      <div className='mt-5 grid lg:gap-x-5 lg:grid-cols-1 '>

        <Form.Item className='block mb-2 text-sm font-medium text-gray-700' name="title" label="Title" rules={[{ required: true, message: 'กรุณาระบุชื่อผู้ใช้' }]}>
          <Input
            className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none"
            placeholder="Title"
          />
        </Form.Item>

        <Form.Item className='block mb-2 text-sm font-medium text-gray-700' name="workload" label="Workload" rules={[{ required: true, message: 'กรุณาระบุชื่อผู้ใช้' }]}>
          <InputNumber
            className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none"
            placeholder="Workload"
            min={0}
            max={100}
            step={1}
          />
        </Form.Item>

        <Form.Item className='block mb-2 text-sm font-medium text-gray-700' name="type" label="Type" rules={[{ required: true, message: 'กรุณาระบุตำเเหน่ง' }]}>
          <Select
            defaultValue=""
            style={{ width: '100%' }}
            options={typeOptions}
          />
        </Form.Item>

        {isImage && (
          <>
            <Form.Item
              className='block mb-2 text-sm font-medium text-gray-700'
              name="image_multiple"
              label="โหมดรูป"
              initialValue={0}
            >
              <Select style={{ width: '100%' }} options={CUSTOMFIELD_IMAGE_MODE_OPTIONS} />
            </Form.Item>

            <Form.Item
              className='block mb-2 text-sm font-medium text-gray-700'
              name="image_workload"
              label="Workload ต่อรูป (บวกเพิ่มต่อ 1 รูปที่อัป)"
            >
              <InputNumber
                className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none"
                placeholder="Workload ต่อรูป"
                min={0}
                max={100}
                step={1}
              />
            </Form.Item>
          </>
        )}

        <Form.Item
          className='block mb-2 text-sm font-medium text-gray-700'
          name="required"
          label="Required"
          valuePropName="checked"
          initialValue={false}
        >
          <Checkbox>Required</Checkbox>
        </Form.Item>

        <Form.Item 
          className='block mb-2 text-sm font-medium text-gray-700' 
          name="example_image" 
          label="Example Image"
        >
          <Upload
            listType="picture"
            maxCount={1}
            beforeUpload={() => false}
            onChange={(info) => {
              if (info.fileList.length > 0) {
                const file = info.fileList[0].originFileObj;
                if (file) {
                  const reader = new FileReader();
                  reader.onload = (e) => {
                    formRef.current?.setFieldValue('example_image', e.target.result);
                  };
                  reader.readAsDataURL(file);
                }
              } else {
                formRef.current?.setFieldValue('example_image', null);
              }
            }}
            onRemove={() => {
              formRef.current?.setFieldValue('example_image', null);
            }}
          >
            <Button icon={<UploadOutlined />}>Upload Example Image</Button>
          </Upload>
        </Form.Item>

        <Form.Item 
          className='block mb-2 text-sm font-medium text-gray-700' 
          name="description" 
          label="Description"
        >
          <Input.TextArea
            className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none"
            placeholder="Enter description"
            rows={4}
          />
        </Form.Item>

        
      </div>
    </Form>
  );
}

export default FormEmployee;

